import { AccountInfo } from '@azure/msal-browser';
import { get } from 'lodash';

// @ts-ignore
declare const CONFIG;
const { groupRead, groupWrite, groupOrder } = CONFIG.authms;

const getUserGroups = (user: AccountInfo | null): string[] => {
  const groups = get(user, "idTokenClaims.groups");
  return groups || [];
};

const hasAccess = (user: AccountInfo | null | undefined) => {
  if (user) {
    const groups = getUserGroups(user);
    if ([groupRead, groupWrite, groupOrder].some(group => groups.includes(group))) {
      return true;
    }
  }
  return false;
};

const hasWriteAccess = (user: AccountInfo | null | undefined) => {
  if (user) {
    const groups = getUserGroups(user);
    if (groups.includes(groupWrite)) {
      return true;
    }
  }
  return false;
};

const hasOrderAccess = (user: AccountInfo | null | undefined) => {
  if (user) {
    const groups = getUserGroups(user);
    if (groups.includes(groupOrder)) {
      return true;
    }
  }
  return false;
};

const isBrowserStackLocal = () => {
  return window.location.hostname.endsWith("bs-local.com");
}

const isMockEnabled = () => {
  return import.meta.env.VITE_ENABLE_MOCK || false;
}

export { hasAccess, hasWriteAccess, hasOrderAccess, isBrowserStackLocal, isMockEnabled, groupRead, groupWrite, groupOrder };
